/*
 * saveNodes之前对数据进行过滤
 * */

import _ from 'lodash'
import Util from '../../../utils/utils'

let projectId = ''
let indexPageId = ''
let hasLineFeed = false

const handleImg = function handleImg (item) {
	if (item.value.indexOf(item.from) !== -1 || item.from.indexOf(item.value) !== -1) {
		// 没有修改
		return
	}

	let imgUrl = item.value
	let index = imgUrl.indexOf(indexPageId) + indexPageId.length + 1
	item.value = imgUrl.substring(index) //去掉图库带过来的前导projectId
	return item
}

const handleBgImg = function handleBgImg (item) {
	let _item = handleImg(item)
	if (!_item) return

	let bgItem = _.cloneDeep(_item)
	bgItem.action = 'DOM_CHANGE'
	bgItem.attr = 'style'
	// bgItem.value = service.filterImgPath(bgItem.originSrc);  // 原始图片 过滤值

	let url = bgItem.value
	url = url.replace(/[?&]version=\d+/, '')
	if (url.lastIndexOf('?') === -1) {
		url += '?v=' + Util.getRandomString(8)
	} else {
		url += '&v=' + Util.getRandomString(8)
	}
	bgItem.value = bgItem.styleText.replace(/(background-image\s*:\s*url\()([^)]*)\)/, '$1' + url + ')')
	return bgItem
}

const handleHref = function handleHref (item) {
	item = _.omit(item, 'placeholder')
	item.value = item.value && item.value !== '' && item.value !== 'http://' ? item.value : 'javascript:void(0);'
	return item
}

const handleAlt = function handleAlt (item) {
	item = _.omit(item, 'placeholder')
	if (item.objectType && item.objectType === 'CommonType') {
		// 剔除静态数据中自定义的验证信息
		item = _.omit(item, 'objectType')
		item = _.omit(item, 'validateProperty')
	}
	return item
}

const handleTarget = function handleTarget (item) {
	item.value = item.value === '_blank' ? '_blank' : '_self'
	return item
}

let replaceFun = function (reg, value, replaceStr) {
	let doExec = reg.exec(value)
	let index = 0 //防止死循环，200次后结束
	while (doExec) {
		value = value.replace(reg, function (a, b, c, d, e) {
			var space = ''
			for (var i = 0; i < c.length; i++) {
				space += replaceStr
			}
			return b + space + d
		})
		doExec = reg.exec(value)
		index++
		if (index === 5000) {
			return
		}
	}
	return value
}

const handleHtml = function handleHtml (item) {
	let regtab = /(.*>[^\s|^<]*)(\t+)([^\s]*.*<.*)/g
	item.value = replaceFun(regtab, item.value, '&nbsp;&nbsp;')
	let regSpace = /(.*>[^\s|^<]*)(\s+)([^\s]*.*<.*)/g
	item.value = replaceFun(regSpace, item.value, '&nbsp;')
	if (hasLineFeed) {
		item.value = item.value
			.replace(/<p><br><\/p>/g, '<p></p>')
			.replace(/<\/p><p>/g, '<br>')
			.replace(/^<p>/, '')
			.replace(/<\/p>$/, '')
	} else {
		item.value = item.value
			.replace(/<p>/g, '')
			.replace(/<\/p>/g, '')
			.replace(/<br>/g, '')
	}
	/*当文字允许删除之后*/
	item.value = item.value ? item.value : '&nbsp;&nbsp;'
	return item
}

const getItem = function getItem (item) {
	// 属性类型
	switch (item.attr) {
		case 'css':
			/*var resultItem = [];
				var imgResult = handleImg(item);
				if( imgResult ) {
					resultItem.push(imgResult);
					resultItem.push(handleBgImg(item));
				}
				return resultItem;*/
			return handleBgImg(item)
		case 'src':
			return handleImg(item)
		case 'href':
			return handleHref(item)
		case 'target':
			return handleTarget(item)
		case 'text':
			return handleHtml(item)
		case 'alt':
			return handleAlt(item)
		default:
			return item
	}
}

const combinedATags = function combinedATags (data) {
	//console.log(data, '走到这里来了')
	let title = _.find(data, { additional: 'WRAP', attr: 'title' }),
		href = _.find(data, { additional: 'WRAP', attr: 'href' }),
		target = _.find(data, { additional: 'WRAP', attr: 'target' }),
		rel = _.find(data, { additional: 'WRAP', attr: 'rel' }),
		node,
		tag
	data = _.reject(data, { additional: 'WRAP' }) //获取没有包裹的node
	const isRel = rel && rel.value ? `rel="${rel.value}"` : ''
	if ((title && title.value) || (href && href.value && href.value !== 'javascript:void(0);')) {
		// tag = '<a title="' + title.value + '" target="' + target.value + '" href="' + href.value + '"></a>'
		tag = `<a title="${title.value}" target="${target.value}" href="${href.value}" ${isRel}></a>`
		node = _.assign(title, { value: tag, attr: 'wrap' })
		data.push(node)
	} else if (href && href.value && href.value === 'javascript:void(0);') {
		tag = `<a title="${title.value}" target="${target.value}" href="${href.value}" ${isRel}></a>`
		node = _.assign(title, { value: tag, attr: 'wrap' })
		data.push(node)
	}
	return data
}

const filterOptions = function filterOptions (projId, pageId, jquery, options, hasWrap, isOpen, line) {
	projectId = projId
	indexPageId = pageId
	hasLineFeed = line
	let unWrapOptions = _.reject(options, { additional: 'WRAP' }) // 原始的图片
	let nodes = []
	_.forEach(options, function (option) {
		option = _.omit(option, 'title') // 移除input前的label
		option = getItem(option)
		if (option && !_.isArray(option)) {
			nodes.push(option)
		} else if (option && _.isArray(option) && option.length) {
			nodes.push(option[0], option[1])
		}
	})
	if (!hasWrap) {
		nodes = combinedATags(nodes)
	} else {
		nodes = isOpen ? combinedATags(nodes) : _.reject(nodes, { additional: 'WRAP' })
	}
	let inlineTagObj = _.filter(nodes, { attr: 'text' })
	if (inlineTagObj.length > 0) {
		nodes.push({
			action: 'DOM_CHANGE',
			attr: 'data-inline-tag',
			nodeId: inlineTagObj[0].nodeId,
			value: 'tag'
		})
	}
	console.log(nodes)
	console.log('nodes')
	return nodes
}

export default filterOptions
